$(document).on('change','.js-qty__num',function(){
    var qty = $(this).val();
    plusminusnum(qty);
});

$(document).on('click','.js-qty__adjust--minus',function(){
    var qty = $(this).prev().val();
    plusminusnum(qty);
});
$(document).on('click','.js-qty__adjust--plus',function(){
    var qty = $(this).prev().prev().val();
    plusminusnum(qty);
});
function plusminusnum(qty){
    $('.variant-wrapper .variant-input input').each(function(){
        var optionval = $(this).val().split('-');
        console.log(optionval);
        var oprionone = parseInt(optionval[0]);
        var optiontwo = parseInt(optionval[1]); 
      if(qty >= oprionone && qty <= optiontwo){
            $(this).trigger('click');
        }
        else if(qty >= oprionone){
            $(this).trigger('click');
        }
    });
    $('.product-custom-form-block .product-single__variants option').each(function(){
        var selectval = $(this).attr('valuetitle').split('-');
        var selectone = parseInt(selectval[0]);
        var selecttwo = parseInt(selectval[1]);
        if(qty >= selectone && qty <= selecttwo){
            $(this).trigger('change');
            $(".product-custom-form-block .product-single__variants option:selected").each(function(){
                $(this).removeAttr("selected");
            });
            $(this).attr("selected", "selected");
            console.log($(this).attr("selected", "selected"));
        }
        else if(qty >= selectone){
            $(this).trigger('change');
            $(".product-custom-form-block .product-single__variants option:selected").each(function(){
                $(this).removeAttr("selected");
            });
            $(this).attr("selected", "selected");
            console.log($(this).attr("selected", "selected"));
        }
    });
    var productprice = $(".product-block-main-price .product__price[data-product-price]").text().split('$');
    var productpriceint =  parseFloat(productprice[1]);
    var productqty = parseInt(qty);
    var productpricetotal = productpriceint * productqty;
    var productpricefloat = parseFloat(productpricetotal).toFixed(2);
    $(".product-block-total-price .product__price[data-product-customprice]").html(productpricefloat).prepend('$'); 
    $('.product__quantity .js-qty__num').val(productqty);
    $('.product-custom-form-block .product-single__properties').val(productpriceint);
}
$(document).on('change','.js-qty__num--bundle',function(){
    var qty = $(this).val();
    bundleplusminusnum(qty);
});
$(document).on('click','.js-qty__adjust--minus--bundle',function(){
    var qty = $(this).prev().val();
    bundleplusminusnum(qty);
});
$(document).on('click','.js-qty__adjust--plus--bundle',function(){
    var qty = $(this).prev().prev().val();
    bundleplusminusnum(qty);
});
function bundleplusminusnum(qty){
    var newarray= [];
    $('.bundleproduct-single__variants option').each(function(){
        var selectval = $(this).attr('data-bundlevarianttitle').split('-');
        var selectone = parseInt(selectval[0]);
        var selecttwo = parseInt(selectval[1]);
        if(qty >= selectone && qty <= selecttwo){
            $(this).trigger('change');
            $(".bundleproduct-single__variants option:selected").each(function(){
                $(this).removeAttr("selected");
            });
            $(this).attr("selected", "selected");
            console.log($(this).attr("selected", "selected"));
            var priceoption = $(this).attr('data-bundlevariantpricemoney');
            newarray.push(priceoption);
        }
        else if(qty >= selectone){
            $(this).trigger('change');
            $(".bundleproduct-single__variants option:selected").each(function(){
                $(this).removeAttr("selected");
            });
            $(this).attr("selected", "selected");
            console.log($(this).attr("selected", "selected"));
            var priceoption = $(this).attr('data-bundlevariantpricemoney');
            newarray.push(priceoption);
        }
    });

    var newarraylastvalue = newarray[newarray.length-1];
    var arrayprice = newarraylastvalue.toString();
    $(".product-block-bundle-price .product__price[data-product-price]").html(arrayprice);
    var productprice = $(".product-block-bundle-price .product__price[data-product-price]").text().split('$');
    var productpriceint =  parseFloat(productprice[1]);
    var productqty = parseInt(qty);
    var productpricetotal = productpriceint * productqty;
    var productpricefloat = parseFloat(productpricetotal).toFixed(2);
    $(".product-bundle-block-price .product__price[data-product-customprice]").html(productpricefloat).prepend('$');
    $('.product__quantity .js-qty__num--bundle').val(productqty);
}
$('.woodenbox-section').click(function(){
    if($('.bundleproduct-modal').hasClass('is-open')){
        $('body').removeClass('modalwrapper');
        $('.bundleproduct-modal').removeClass('is-open');
    }
    else{
        $('body').addClass('modalwrapper');
        $('.bundleproduct-modal').addClass('is-open');
    }
});
$('#close-bundle-product').click(function(){
    $('body').removeClass('modalwrapper');
    $('body').removeClass('unloading');
    $('.bundleproduct-modal').removeClass('is-open');
});
$('.bundleoverlay').click(function(){
    $('body').removeClass('modalwrapper');
    $('body').removeClass('unloading');
    $('.bundleproduct-modal').removeClass('is-open');
});
$('#btn-addtocart-custom').click(function(){
    console.log('hello');
    var qtynumber = $('.product__quantity .js-qty__num').val();
    var element = $('.product-custom-form-block .product-single__variants').find('option:selected'); 
    var variantprice = element.attr("data-variantprice");
    var variantvalue = element.attr("value");
    var variantpropertiesval = $('.product-custom-form-block .product-single__properties').val(); 
    var variantproperties = {'variantproperty':variantpropertiesval};
    console.log(variantvalue);
    customCartFunctionslity();    
});
function customCartFunctionslity(){
    $.ajax({
        method:'get',
        url:'/cart',
        dataType: 'json',
        success: updateCart,
        complete: function(){
            console.log('complete');
        }
        });
}
function updateCart(data){
    var dataitems = data.items;
    var customproductid = $('.product-section').attr('data-product-id');
    console.log(dataitems,'dataitmes');
    var productdata = [];
    $(dataitems).each(function(key,value){ 
        var item = {};
        if(value.product_id ==  customproductid){
            item['productid'] = value.product_id;
            item['quantity'] = value.quantity;
            item['variantid'] = value.variant_id;
            productdata.push(item);
        }
    });

    if(productdata.length > 0){
      var updateqty = $('.product__quantity .js-qty__num').val(); 
      $.each( productdata, function( key, value ) {
        if(value.productid == customproductid){
            updateCartData(value,updateqty);
        }
        else{
            cartAdddata();
        }
      });
    }
    else{
        cartAdddata();
    }
}
function cartAdddata(){
    var qtynumber = $('.product__quantity .js-qty__num').val();
    var variantselectval = $('.product-custom-form-block .product-single__variants').val();
    $.ajax({
        method:'post',
        url:'/cart/add',
        data: {id:variantselectval,quantity:qtynumber},
        dataType: 'json',
        success:function(data){
            window.location="/cart"
        },
        complete: function(){
            console.log('complete');
        }
    }); 
}
function updateCartData(value,updateqty){
    console.log(value);
    var updateqty = parseInt(updateqty) + parseInt(value.quantity);
    var updatevariantid = '';
    $('.product-custom-form-block .product-single__variants option').each(function(){
        var selectval = $(this).attr('valuetitle').split('-');
        var selectone = parseInt(selectval[0]);
        var selecttwo = parseInt(selectval[1]);
        if(updateqty >= selectone && updateqty <= selecttwo){
            $(this).trigger('change');
            $(".product-custom-form-block .product-single__variants option:selected").each(function(){
                $(this).removeAttr("selected");
            });
            $(this).attr("selected", "selected");
        }
        else if(updateqty >= selectone){
            $(this).trigger('change');
            $(".product-custom-form-block .product-single__variants option:selected").each(function(){
                $(this).removeAttr("selected");
            });
            $(this).attr("selected", "selected");
        }
    });
    var variantselectval = $('.product-custom-form-block .product-single__variants').val();
    $.ajax({
        method:'post',
        url:'/cart/change',
        data: {id:value.variantid,quantity:0},
        dataType: 'json',
        success:function(data){
            $.ajax({
                method:'post',
                url:'/cart/add',
                data: {id:variantselectval,quantity:updateqty},
                dataType: 'json',
                success:function(data){
                    window.location="/cart"
                },
                complete: function(){
                    console.log('complete');
                }
            });
        },
        complete: function(){
            console.log('complete');
        }
    });
}
$('#btn-addtocart-bundlecustom').click(function(){
    console.log('hello');
    $('body').removeClass('modalwrapper');
    $('body').removeClass('unloading');
    $('.bundleproduct-modal').removeClass('is-open');
    var element = $('.bundleproduct-single__variants').find('option:selected'); 
    var variantprice = element.attr("data-bundlevariantprice");
    $.ajax({
    method:'get',
    url:'/cart',
    dataType: 'json',
    success: bundleupdateCart,
    complete: function(){
        console.log('complete');
    }
    });
});
function bundleupdateCart(data){
    var dataitems = data.items;
    var customproductid = $('.bundleproduct-modal').attr('data-bundleproductid');
    var productdata = [];
    $(dataitems).each(function(key,value){ 
        var item = {};
        if(value.product_id ==  customproductid){
            item['productid'] = value.product_id;
            item['quantity'] = value.quantity;
            item['variantid'] = value.variant_id;
            productdata.push(item);
        }
    });
    if(productdata.length > 0){
      var updateqty = $('.product__quantity .js-qty__num--bundle').val(); 
      $.each( productdata, function( key, value ) {
        if(value.productid == customproductid){
            bundleupdateCartData(value,updateqty);
        }
        else{
            bundlecartAdddata();
        }
      });
    }
    else{
        bundlecartAdddata();
    }
}
function bundlecartAdddata(){
    var qtynumber = $('.product__quantity .js-qty__num--bundle').val();
    var variantselectval = $('.bundleproduct-single__variants').val();
    $.ajax({
        method:'post',
        url:'/cart/add',
        data: {id:variantselectval,quantity:qtynumber},
        dataType: 'json',
        success:function(data){
            // window.location="/cart"
            $('body').removeClass('modalwrapper');
            $('.bundleproduct-modal').removeClass('is-open');
        },
        complete: function(){
            console.log('complete');
        }
    }); 
}
function bundleupdateCartData(value,updateqty){
    console.log(value);
    var updateqty = parseInt(updateqty) + parseInt(value.quantity);
    var updatevariantid = '';
    $('.bundleproduct-single__variants option').each(function(){
        var selectval = $(this).attr('data-bundlevarianttitle').split('-');
        var selectone = parseInt(selectval[0]);
        var selecttwo = parseInt(selectval[1]);
        if(updateqty >= selectone && updateqty <= selecttwo){
            $(this).trigger('change');
            $(".bundleproduct-single__variants option:selected").each(function(){
                $(this).removeAttr("selected");
            });
            $(this).attr("selected", "selected");
        }
        else if(updateqty >= selectone){
            $(this).trigger('change');
            $(".bundleproduct-single__variants option:selected").each(function(){
                $(this).removeAttr("selected");
            });
            $(this).attr("selected", "selected");
        }
    });
    
    $.ajax({
        method:'post',
        url:'/cart/change',
        data: {id:value.variantid,quantity:0},
        dataType: 'json',
        success:function(data){
            var variantselectval = $('.bundleproduct-single__variants').val();
            console.log(variantselectval,'bundlevariantselectval');
            $.ajax({
                method:'post',
                url:'/cart/add',
                data: {id:variantselectval,quantity:updateqty},
                dataType: 'json',
                success:function(data){
                    // window.location="/cart"
                    $('body').removeClass('modalwrapper');
                    $('.bundleproduct-modal').removeClass('is-open');
                },
                complete: function(){
                    console.log('complete');
                }
            });
        },
        complete: function(){
            console.log('complete');
        }
    });
}
